import { get } from './apiService';

/**
 * GET /ping response shape.
 *
 * `version` is the BE API version (or "UNKNOWN" in debug builds).
 *
 * `appVersionRequired` is the optional FE minimum-version contract. When
 * present (and matching `MAJOR.MINOR.PATCH` server-side, which the BE
 * regex-guards), the FE is expected to refuse to keep running if
 * `VITE_VERSION` is strictly less than this value — see
 * `versionCheckService.runVersionCheck()`. Absent means "no hard cutoff
 * in effect" and the FE proceeds normally.
 */
export interface PingResponse {
  pong: string;
  version: string;
  appVersionRequired?: string;
}

export async function pingApi(): Promise<PingResponse> {
  return get<PingResponse>('/ping');
}
